export function isTargetValueSelected(
  targetValue: string | null | undefined,
  selectedValue: string | number | null | undefined,
): boolean {
  if (
    targetValue === null ||
    targetValue === undefined ||
    selectedValue === null ||
    selectedValue === undefined ||
    selectedValue === ''
  ) {
    return false
  }

  return targetValue === String(selectedValue)
}
